<template>
    <v-container class="pa-5" fluid>
        <page-title>
            {{ pageTitle }}
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="onClose"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container>
                    <v-stepper v-model="stepper">
                        <v-progress-linear
                            color="blue"
                            indeterminate
                            :active="localizationsLoading"
                            absolute
                            height="3"
                        />
                        <v-overlay :value="localizationsLoading" opacity="0" absolute />

                        <v-stepper-header class="no-shadow">
                            <v-stepper-step step="1" :complete="stepper > 1" :color="stepper > 1 ? 'success' : 'primary'">
                                Dane kampanii
                            </v-stepper-step>

                            <v-divider />

                            <v-stepper-step step="2" :complete="stepper > 2" :color="stepper > 2 ? 'success' : 'primary'">
                                Lokalizacje
                            </v-stepper-step>
                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <OutdoorsCampaignData
                                    :action="action"
                                    :campaign-data="campaign"
                                    @show-localizations="showLocalizations"
                                    @localizations-loading="toggleLocalizationLoading"
                                    @add-product="addProduct"
                                    @edit-product="editProduct"
                                />
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <OutdoorsCampaignLocalizations
                                    :action="action"
                                    :action-loading="actionLoading"
                                    :campaign-data="campaign"
                                    @show-campaign-data="showCampaignData"
                                    @save-outdoors-campaign="saveCampaign"
                                />
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'
import store from '@/./store'
import { errorHandler } from '@/utils/errorHandler'
import PageTitle from '@/components/common/PageTitle'
import OutdoorsCampaignData from './OutdoorsCampaignData'
import OutdoorsCampaignLocalizations from './OutdoorsCampaignLocalizations'
import customFilters from '@/mixins/customFilters'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'OutdoorsCampaign',
    components: {
        PageTitle,
        OutdoorsCampaignData,
        OutdoorsCampaignLocalizations

    },
    mixins: [ customFilters, tooltipDelay ],
    beforeRouteEnter(to, from, next) {
        if (typeof to.params.id !== 'undefined') {
            store.dispatch('outdoors/outdoorsCampaigns/getOutdoorsCampaign', to.params.id)
                .then(response => {
                    next(vm => {
                        vm.action = 'updateOutdoorsCampaign'
                        response.data.name ? vm.pageTitle = `Kampania - ${response.data.name}` : vm.pageTitle = 'Kampania'
                        vm.campaign = Object.assign({}, response.data)
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        } else {
            next(vm => {
                const storedCampaign = store.state.outdoors.outdoorsCampaigns.outdoorsCampaigns.isCampaignCreated

                vm.action = storedCampaign ? 'updateOutdoorsCampaign' : 'createOutdoorsCampaign'
                vm.pageTitle = 'Nowa kampania'
            })
        }
    },
    beforeRouteLeave(to, from, next) {
        if (!to.params.saveInStore) {
            this.$store.dispatch('outdoors/outdoorsCampaigns/clearCampaignCreate')
            next()
        } else {
            next()
        }
    },
    data() {
        return {
            pageTitle: null,
            campaign: {},
            stepper: 1,
            actionLoading: false,
            localizationsLoading: false,
            action: null

        }
    },
    methods: {
        addProduct() {
            router.push({
                name: 'outdoorsCampaignsCampaignsProductAddProduct',
                params: {
                    saveInStore: true
                }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        editProduct(index) {
            router.push({
                name: 'outdoorsCampaignsCampaignsProductEditProduct',
                params: {
                    index: index,
                    saveInStore: true
                }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        toggleLocalizationLoading(value) {
            this.localizationsLoading = value
        },
        showLocalizations(campaign) {
            this.campaign = campaign
            this.stepper = 2
        },
        showCampaignData() {
            if (this.action === 'createOutdoorsCampaign') this.action = 'updateOutdoorsCampaign'
            this.stepper = 1
        },
        saveCampaign() {
            this.actionLoading = true

            this.$store.dispatch('showNotification', {
                type: 'success',
                message: 'Kampania została zedytowana.'
            })
            this.onClose()

        },
        onClose() {
            this.actionLoading = false
            setTimeout(() => {
                this.campaign = {}
            }, 500)
            this.$store.dispatch('outdoors/outdoorsCampaigns/clearIsCampaignCreated')
            this.$router.push({ name: 'outdoorsCampaignsCampaigns' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>